// extracted by mini-css-extract-plugin
export var arrows = "_6b-5";
export var decrementer = "_6b-9";
export var disabled = "_6b-3";
export var error = "_6b-1";
export var hiddenText = "_6b-a";
export var incrementer = "_6b-8";
export var input = "_6b-7";
export var inputWrapper = "_6b-0";
export var leadingIcon = "_6b-b";
export var readonly = "_6b-2";
export var regular = "_6b-6";
export var small = "_6b-4";